jQuery(document).ready(function($){

	/**
	 * Header Sticky
	 *
	 * Handles toggling the sticky header
	 */

	$(window).scroll(function() {
		let scroll = $(window).scrollTop();

		if ( scroll > 40 ) {
			$("header").addClass("sticky");
		} else {
			$("header").removeClass("sticky");
		}
	});


	/**
	 * Hero Search - Scroll
	 *
	 * Handles scrolling of Hero Search component
	 */

	$("#scroll").click(function() {
		let height = ( $('.section--hero-search').position().top + $('.section--hero-search').outerHeight(true) ) + 44;

		$([document.documentElement, document.body]).animate({
			scrollTop: height
		}, 600);
	});


	/**
	 * Job Search - 'Contract' Job Type
	 *
	 * Handles toggling job type 'Contract' to contract job search page
	 */

	$('#search-filter-form-766 .sf-field-taxonomy-job-type .sf-item-33 .sf-input-radio').click(function() {
		// Contract job type active
		window.location.href = 'contract/?_sft_job-type=contract';
	});


	/**
	 * Job Search - 'Permanent' Job Type
	 *
	 * Handles toggling job type 'Permanent' to contract job search page
	 */

	$('#search-filter-form-1585 .sf-field-taxonomy-job-type .sf-item-32 .sf-input-radio').click(function() {
		// Permanent job type active
		window.location.href = '/jobs/?_sft_job-type=permanent';
	});


	/**
	 * Gravity Forms File Upload Button
	 *
	 * Handles appending the uploaded file name to a new paragraph field
	 */

	$( 'input[type="file"]' ).each( function() {
		let input = $(this);

		input.on( 'change', function( e ) {
			let fileName = '';

			if ( e.target.value ) {
				fileName = e.target.value.split( '\\' ).pop();
				$(this).parent().find('.file-uploaded').remove();
				$(this).parent().append('<p class="file-uploaded">File uploaded: ' + fileName + '</p>');
			}
		});
	});

});
